 // map some common timezones to representative city coordinates (lat,lng,zoom)
export const timezoneToCoords = tz => {
  if (!tz || typeof tz !== "string") return null;
  const map = {
    // Pacific UTC-11:00
    "Pacific/Midway": { lat: -14.3617, lng: -170.7183, zoom: 10 },
    "Pacific/Niue": { lat: -19.0544, lng: -169.8672, zoom: 10 },
    "Pacific/Pago_Pago": { lat: -14.2781, lng: -170.7025, zoom: 10 },

    // Pacific UTC-10:00
    "Pacific/Honolulu": { lat: 21.3099, lng: -157.8581, zoom: 10 },
    "Pacific/Rarotonga": { lat: -21.2036, lng: -159.7775, zoom: 10 },
    "Pacific/Tahiti": { lat: -17.6797, lng: -149.4068, zoom: 10 },
    "US/Hawaii": { lat: 21.3099, lng: -157.8581, zoom: 10 },

    // Pacific UTC-09:30
    "Pacific/Marquesas": { lat: -9.0479, lng: -140.0328, zoom: 10 },

    // America/Pacific UTC-09:00
    "America/Adak": { lat: 51.88, lng: -176.6581, zoom: 10 },
    "Pacific/Gambier": { lat: -23.1353, lng: -134.9686, zoom: 10 },

    // Alaska UTC-08:00
    "America/Anchorage": { lat: 61.2181, lng: -149.9003, zoom: 8 },
    "America/Juneau": { lat: 58.3019, lng: -134.4197, zoom: 10 },
    "America/Metlakatla": { lat: 55.1311, lng: -131.5764, zoom: 10 },
    "America/Nome": { lat: 64.5011, lng: -165.4064, zoom: 10 },
    "America/Sitka": { lat: 57.0531, lng: -135.33, zoom: 10 },
    "America/Yakutat": { lat: 59.5469, lng: -139.7272, zoom: 10 },
    "Pacific/Pitcairn": { lat: -25.0667, lng: -130.1, zoom: 10 },
    "US/Alaska": { lat: 61.2181, lng: -149.9003, zoom: 8 },

    // America/Pacific UTC-07:00
    "America/Creston": { lat: 49.0958, lng: -116.5133, zoom: 10 },
    "America/Dawson": { lat: 64.0608, lng: -139.1283, zoom: 10 },
    "America/Dawson_Creek": { lat: 55.7597, lng: -120.2375, zoom: 10 },
    "America/Fort_Nelson": { lat: 58.8053, lng: -122.7, zoom: 10 },
    "America/Hermosillo": { lat: 29.0729, lng: -110.9559, zoom: 10 },
    "America/Los_Angeles": { lat: 34.0522, lng: -118.2437, zoom: 12 },
    "America/Phoenix": { lat: 33.4484, lng: -112.074, zoom: 12 },
    "America/Tijuana": { lat: 32.5149, lng: -117.0382, zoom: 10 },
    "America/Vancouver": { lat: 49.2827, lng: -123.1207, zoom: 12 },
    "America/Whitehorse": { lat: 60.7212, lng: -135.0568, zoom: 10 },
    "Canada/Pacific": { lat: 49.2827, lng: -123.1207, zoom: 12 },
    "US/Arizona": { lat: 33.4484, lng: -112.074, zoom: 12 },
    "US/Pacific": { lat: 34.0522, lng: -118.2437, zoom: 12 },

    // America/Mountain UTC-06:00
    "America/Belize": { lat: 17.2515, lng: -88.76, zoom: 10 },
    "America/Boise": { lat: 43.615, lng: -116.2023, zoom: 10 },
    "America/Cambridge_Bay": { lat: 69.1081, lng: -105.0581, zoom: 10 },
    "America/Chihuahua": { lat: 28.6353, lng: -106.0889, zoom: 10 },
    "America/Costa_Rica": { lat: 9.7489, lng: -83.7534, zoom: 10 },
    "America/Denver": { lat: 39.7392, lng: -104.9903, zoom: 12 },
    "America/Edmonton": { lat: 53.5461, lng: -113.4938, zoom: 12 },
    "America/El_Salvador": { lat: 13.7942, lng: -88.8965, zoom: 10 },
    "America/Guatemala": { lat: 14.6349, lng: -90.5069, zoom: 10 },
    "America/Inuvik": { lat: 68.3607, lng: -133.7175, zoom: 10 },
    "America/Managua": { lat: 12.1364, lng: -86.2514, zoom: 10 },
    "America/Mazatlan": { lat: 23.2494, lng: -106.4115, zoom: 10 },
    "America/Ojinaga": { lat: 29.5603, lng: -104.4197, zoom: 10 },
    "America/Regina": { lat: 50.4452, lng: -104.6189, zoom: 10 },
    "America/Swift_Current": { lat: 50.2833, lng: -107.7833, zoom: 10 },
    "America/Tegucigalpa": { lat: 14.0723, lng: -87.1921, zoom: 10 },
    "America/Yellowknife": { lat: 62.454, lng: -114.3718, zoom: 10 },
    "Canada/Mountain": { lat: 53.5461, lng: -113.4938, zoom: 12 },
    "Pacific/Easter": { lat: -27.1127, lng: -109.3497, zoom: 10 },
    "Pacific/Galapagos": { lat: -0.7892, lng: -91.0544, zoom: 10 },
    "US/Mountain": { lat: 39.7392, lng: -104.9903, zoom: 12 },

    // America/Central UTC-05:00
    "America/Atikokan": { lat: 48.7589, lng: -91.6219, zoom: 10 },
    "America/Bahia_Banderas": { lat: 20.7, lng: -105.25, zoom: 10 },
    "America/Bogota": { lat: 4.711, lng: -74.0721, zoom: 12 },
    "America/Cancun": { lat: 21.1619, lng: -86.8515, zoom: 10 },
    "America/Cayman": { lat: 19.3133, lng: -81.2546, zoom: 10 },
    "America/Chicago": { lat: 41.8781, lng: -87.6298, zoom: 12 },
    "America/Eirunepe": { lat: -6.6608, lng: -69.8739, zoom: 10 },
    "America/Guayaquil": { lat: -2.17, lng: -79.9222, zoom: 10 },
    "America/Indiana/Knox": { lat: 41.2958, lng: -86.625, zoom: 10 },
    "America/Indiana/Tell_City": { lat: 37.9531, lng: -86.7678, zoom: 10 },
    "America/Jamaica": { lat: 18.1096, lng: -77.2975, zoom: 10 },
    "America/Lima": { lat: -12.0464, lng: -77.0428, zoom: 12 },
    "America/Matamoros": { lat: 25.8698, lng: -97.5036, zoom: 10 },
    "America/Menominee": { lat: 45.1078, lng: -87.6142, zoom: 10 },
    "America/Merida": { lat: 20.9674, lng: -89.5926, zoom: 10 },
    "America/Mexico_City": { lat: 19.4326, lng: -99.1332, zoom: 12 },
    "America/Monterrey": { lat: 25.6866, lng: -100.3161, zoom: 10 },
    "America/North_Dakota/Beulah": { lat: 47.2642, lng: -101.7781, zoom: 10 },
    "America/North_Dakota/Center": { lat: 47.1164, lng: -101.2993, zoom: 10 },
    "America/North_Dakota/New_Salem": { lat: 46.845, lng: -101.4109, zoom: 10 },
    "America/Panama": { lat: 8.538, lng: -80.7821, zoom: 10 },
    "America/Rainy_River": { lat: 48.7167, lng: -94.5667, zoom: 10 },
    "America/Rankin_Inlet": { lat: 62.8097, lng: -92.0897, zoom: 10 },
    "America/Resolute": { lat: 74.6956, lng: -94.8294, zoom: 10 },
    "America/Rio_Branco": { lat: -9.9758, lng: -67.81, zoom: 10 },
    "America/Winnipeg": { lat: 49.8951, lng: -97.1384, zoom: 12 },
    "Canada/Central": { lat: 49.8951, lng: -97.1384, zoom: 12 },
    "US/Central": { lat: 41.8781, lng: -87.6298, zoom: 12 },

    // America/Eastern UTC-04:00
    "America/Anguilla": { lat: 18.2206, lng: -63.0686, zoom: 10 },
    "America/Antigua": { lat: 17.0608, lng: -61.7964, zoom: 10 },
    "America/Aruba": { lat: 12.5211, lng: -69.9683, zoom: 10 },
    "America/Asuncion": { lat: -25.2637, lng: -57.5759, zoom: 10 },
    "America/Barbados": { lat: 13.1939, lng: -59.5432, zoom: 10 },
    "America/Blanc-Sablon": { lat: 51.4167, lng: -57.1333, zoom: 10 },
    "America/Boa_Vista": { lat: 2.8194, lng: -60.6711, zoom: 10 },
    "America/Campo_Grande": { lat: -20.4697, lng: -54.6201, zoom: 10 },
    "America/Caracas": { lat: 10.4806, lng: -66.9036, zoom: 12 },
    "America/Cuiaba": { lat: -15.6014, lng: -56.0979, zoom: 10 },
    "America/Curacao": { lat: 12.1696, lng: -68.99, zoom: 10 },
    "America/Detroit": { lat: 42.3314, lng: -83.0458, zoom: 12 },
    "America/Dominica": { lat: 15.414, lng: -61.371, zoom: 10 },
    "America/Grand_Turk": { lat: 21.4664, lng: -71.1364, zoom: 10 },
    "America/Grenada": { lat: 12.1165, lng: -61.679, zoom: 10 },
    "America/Guadeloupe": { lat: 16.265, lng: -61.551, zoom: 10 },
    "America/Guyana": { lat: 6.8013, lng: -58.1551, zoom: 10 },
    "America/Havana": { lat: 23.1136, lng: -82.3666, zoom: 12 },
    "America/Indiana/Indianapolis": { lat: 39.7684, lng: -86.1581, zoom: 12 },
    "America/Indiana/Marengo": { lat: 38.3756, lng: -86.345, zoom: 10 },
    "America/Indiana/Petersburg": { lat: 38.4922, lng: -87.2786, zoom: 10 },
    "America/Indiana/Vevay": { lat: 38.7478, lng: -85.0672, zoom: 10 },
    "America/Indiana/Vincennes": { lat: 38.6772, lng: -87.5286, zoom: 10 },
    "America/Indiana/Winamac": { lat: 41.0514, lng: -86.6031, zoom: 10 },
    "America/Iqaluit": { lat: 63.7467, lng: -68.517, zoom: 10 },
    "America/Kentucky/Louisville": { lat: 38.2527, lng: -85.7585, zoom: 12 },
    "America/Kentucky/Monticello": { lat: 36.8297, lng: -84.8491, zoom: 10 },
    "America/Kralendijk": { lat: 12.1017, lng: -68.2653, zoom: 10 },
    "America/La_Paz": { lat: -16.5, lng: -68.15, zoom: 12 },
    "America/Lower_Princes": { lat: 18.0542, lng: -63.0548, zoom: 10 },
    "America/Manaus": { lat: -3.119, lng: -60.0217, zoom: 10 },
    "America/Marigot": { lat: 18.0708, lng: -63.0831, zoom: 10 },
    "America/Martinique": { lat: 14.6415, lng: -61.0242, zoom: 10 },
    "America/Montserrat": { lat: 16.7425, lng: -62.1874, zoom: 10 },
    "America/Nassau": { lat: 25.0443, lng: -77.3504, zoom: 10 },
    "America/New_York": { lat: 40.7128, lng: -74.006, zoom: 12 },
    "America/Nipigon": { lat: 49.0128, lng: -88.2581, zoom: 10 },
    "America/Pangnirtung": { lat: 66.1333, lng: -65.7167, zoom: 10 },
    "America/Port-au-Prince": { lat: 18.5944, lng: -72.3074, zoom: 12 },
    "America/Port_of_Spain": { lat: 10.6918, lng: -61.2225, zoom: 10 },
    "America/Porto_Velho": { lat: -8.7619, lng: -63.9039, zoom: 10 },
    "America/Puerto_Rico": { lat: 18.2208, lng: -66.5901, zoom: 10 },
    "America/Santiago": { lat: -33.4489, lng: -70.6693, zoom: 12 },
    "America/Santo_Domingo": { lat: 18.4861, lng: -69.9312, zoom: 12 },
    "America/St_Barthelemy": { lat: 17.8958, lng: -62.8508, zoom: 10 },
    "America/St_Kitts": { lat: 17.3578, lng: -62.783, zoom: 10 },
    "America/St_Lucia": { lat: 13.9094, lng: -60.9789, zoom: 10 },
    "America/St_Thomas": { lat: 18.3381, lng: -64.8941, zoom: 10 },
    "America/St_Vincent": { lat: 13.2528, lng: -61.1971, zoom: 10 },
    "America/Thunder_Bay": { lat: 48.3822, lng: -89.2461, zoom: 10 },
    "America/Toronto": { lat: 43.6532, lng: -79.3832, zoom: 12 },
    "America/Tortola": { lat: 18.4281, lng: -64.6234, zoom: 10 },
    "Canada/Eastern": { lat: 43.6532, lng: -79.3832, zoom: 12 },
    "US/Eastern": { lat: 40.7128, lng: -74.006, zoom: 12 },

    // South America UTC-03:00
    "America/Araguaina": { lat: -7.1967, lng: -48.2072, zoom: 10 },
    "America/Argentina/Buenos_Aires": {
      lat: -34.6037,
      lng: -58.3816,
      zoom: 12,
    },
    "America/Argentina/Catamarca": { lat: -28.4696, lng: -65.7852, zoom: 10 },
    "America/Argentina/Cordoba": { lat: -31.4201, lng: -64.1888, zoom: 12 },
    "America/Argentina/Jujuy": { lat: -24.1858, lng: -65.2995, zoom: 10 },
    "America/Argentina/La_Rioja": { lat: -29.4331, lng: -66.8506, zoom: 10 },
    "America/Argentina/Mendoza": { lat: -32.8895, lng: -68.8458, zoom: 10 },
    "America/Argentina/Rio_Gallegos": {
      lat: -51.6226,
      lng: -69.2181,
      zoom: 10,
    },
    "America/Argentina/Salta": { lat: -24.7859, lng: -65.4117, zoom: 10 },
    "America/Argentina/San_Juan": { lat: -31.5375, lng: -68.5364, zoom: 10 },
    "America/Argentina/San_Luis": { lat: -33.295, lng: -66.3356, zoom: 10 },
    "America/Argentina/Tucuman": { lat: -26.8083, lng: -65.2176, zoom: 10 },
    "America/Argentina/Ushuaia": { lat: -54.8019, lng: -68.303, zoom: 10 },
    "America/Bahia": { lat: -12.9714, lng: -38.5014, zoom: 10 },
    "America/Belem": { lat: -1.4558, lng: -48.4902, zoom: 10 },
    "America/Cayenne": { lat: 4.9333, lng: -52.3333, zoom: 10 },
    "America/Fortaleza": { lat: -3.7172, lng: -38.5433, zoom: 10 },
    "America/Glace_Bay": { lat: 46.1969, lng: -59.9569, zoom: 10 },
    "America/Goose_Bay": { lat: 53.3167, lng: -60.4167, zoom: 10 },
    "America/Halifax": { lat: 44.6488, lng: -63.5752, zoom: 12 },
    "America/Maceio": { lat: -9.6658, lng: -35.7353, zoom: 10 },
    "America/Moncton": { lat: 46.0878, lng: -64.7782, zoom: 10 },
    "America/Montevideo": { lat: -34.9011, lng: -56.1645, zoom: 12 },
    "America/Paramaribo": { lat: 5.852, lng: -55.2038, zoom: 10 },
    "America/Punta_Arenas": { lat: -53.1638, lng: -70.9171, zoom: 10 },
    "America/Recife": { lat: -8.0476, lng: -34.877, zoom: 10 },
    "America/Santarem": { lat: -2.4431, lng: -54.7081, zoom: 10 },
    "America/Sao_Paulo": { lat: -23.5505, lng: -46.6333, zoom: 12 },
    "America/Thule": { lat: 76.5319, lng: -68.7781, zoom: 10 },
    "Antarctica/Palmer": { lat: -64.7747, lng: -64.0542, zoom: 10 },
    "Antarctica/Rothera": { lat: -67.5681, lng: -68.13, zoom: 10 },
    "Atlantic/Bermuda": { lat: 32.3078, lng: -64.7505, zoom: 10 },
    "Atlantic/Stanley": { lat: -51.6957, lng: -57.8544, zoom: 10 },
    "Canada/Atlantic": { lat: 44.6488, lng: -63.5752, zoom: 12 },

    // Newfoundland UTC-02:30
    "America/St_Johns": { lat: 47.5615, lng: -52.7126, zoom: 10 },
    "Canada/Newfoundland": { lat: 47.5615, lng: -52.7126, zoom: 10 },

    // UTC-02:00
    "America/Godthab": { lat: 64.1836, lng: -51.7214, zoom: 10 },
    "America/Miquelon": { lat: 47.095, lng: -56.3831, zoom: 10 },
    "America/Noronha": { lat: -3.8536, lng: -32.4297, zoom: 10 },
    "Atlantic/South_Georgia": { lat: -54.2817, lng: -36.5081, zoom: 10 },

    // UTC-01:00
    "Atlantic/Cape_Verde": { lat: 16.5388, lng: -23.0418, zoom: 10 },

    // Africa/Atlantic UTC+00:00
    "Africa/Abidjan": { lat: 5.36, lng: -4.0083, zoom: 10 },
    "Africa/Accra": { lat: 5.6037, lng: -0.187, zoom: 10 },
    "Africa/Bamako": { lat: 12.6392, lng: -8.0029, zoom: 10 },
    "Africa/Banjul": { lat: 13.4549, lng: -16.579, zoom: 10 },
    "Africa/Bissau": { lat: 11.8817, lng: -15.6178, zoom: 10 },
    "Africa/Conakry": { lat: 9.6412, lng: -13.5784, zoom: 10 },
    "Africa/Dakar": { lat: 14.7167, lng: -17.4677, zoom: 10 },
    "Africa/Freetown": { lat: 8.4657, lng: -13.2317, zoom: 10 },
    "Africa/Lome": { lat: 6.1256, lng: 1.2251, zoom: 10 },
    "Africa/Monrovia": { lat: 6.2907, lng: -10.7605, zoom: 10 },
    "Africa/Nouakchott": { lat: 18.0735, lng: -15.9582, zoom: 10 },
    "Africa/Ouagadougou": { lat: 12.3714, lng: -1.5197, zoom: 10 },
    "America/Danmarkshavn": { lat: 76.7667, lng: -18.6667, zoom: 10 },
    "America/Scoresbysund": { lat: 70.4842, lng: -21.9686, zoom: 10 },
    "Atlantic/Azores": { lat: 37.7412, lng: -25.6756, zoom: 10 },
    "Atlantic/Reykjavik": { lat: 64.1466, lng: -21.9426, zoom: 10 },
    "Atlantic/St_Helena": { lat: -15.9387, lng: -5.716, zoom: 10 },
    GMT: { lat: 51.4774, lng: -0.0015, zoom: 8 },
    UTC: { lat: 51.4774, lng: -0.0015, zoom: 8 },

    // Europe/Africa UTC+01:00
    "Africa/Algiers": { lat: 36.7538, lng: 3.0588, zoom: 10 },
    "Africa/Bangui": { lat: 4.3947, lng: 18.5582, zoom: 10 },
    "Africa/Brazzaville": { lat: -4.2634, lng: 15.2429, zoom: 10 },
    "Africa/Casablanca": { lat: 33.5731, lng: -7.5898, zoom: 12 },
    "Africa/Douala": { lat: 4.0511, lng: 9.7679, zoom: 10 },
    "Africa/El_Aaiun": { lat: 27.1418, lng: -13.1834, zoom: 10 },
    "Africa/Kinshasa": { lat: -4.4419, lng: 15.2663, zoom: 10 },
    "Africa/Lagos": { lat: 6.5244, lng: 3.3792, zoom: 12 },
    "Africa/Libreville": { lat: 0.4162, lng: 9.4673, zoom: 10 },
    "Africa/Luanda": { lat: -8.839, lng: 13.2894, zoom: 10 },
    "Africa/Malabo": { lat: 3.7504, lng: 8.7371, zoom: 10 },
    "Africa/Ndjamena": { lat: 12.1348, lng: 15.0557, zoom: 10 },
    "Africa/Niamey": { lat: 13.5117, lng: 2.1254, zoom: 10 },
    "Africa/Porto-Novo": { lat: 6.4969, lng: 2.6283, zoom: 10 },
    "Africa/Sao_Tome": { lat: 0.1864, lng: 6.6131, zoom: 10 },
    "Africa/Tunis": { lat: 36.8065, lng: 10.1815, zoom: 10 },
    "Atlantic/Canary": { lat: 28.2916, lng: -16.6291, zoom: 10 },
    "Atlantic/Faroe": { lat: 62.0077, lng: -6.79, zoom: 10 },
    "Atlantic/Madeira": { lat: 32.7607, lng: -16.9595, zoom: 10 },
    "Europe/Dublin": { lat: 53.3498, lng: -6.2603, zoom: 12 },
    "Europe/Guernsey": { lat: 49.4659, lng: -2.5854, zoom: 10 },
    "Europe/Isle_of_Man": { lat: 54.2361, lng: -4.5481, zoom: 10 },
    "Europe/Jersey": { lat: 49.1919, lng: -2.1071, zoom: 10 },
    "Europe/Lisbon": { lat: 38.7223, lng: -9.1393, zoom: 12 },
    "Europe/London": { lat: 51.5074, lng: -0.1278, zoom: 12 },

    // Europe/Africa UTC+02:00
    "Africa/Blantyre": { lat: -15.7861, lng: 35.0058, zoom: 10 },
    "Africa/Bujumbura": { lat: -3.3961, lng: 29.3947, zoom: 10 },
    "Africa/Cairo": { lat: 30.0444, lng: 31.2357, zoom: 12 },
    "Africa/Ceuta": { lat: 35.8883, lng: -5.3215, zoom: 10 },
    "Africa/Gaborone": { lat: -24.6282, lng: 25.9231, zoom: 10 },
    "Africa/Harare": { lat: -17.8292, lng: 31.0522, zoom: 10 },
    "Africa/Johannesburg": { lat: -26.2041, lng: 28.0473, zoom: 12 },
    "Africa/Khartoum": { lat: 15.5007, lng: 32.5599, zoom: 10 },
    "Africa/Kigali": { lat: -1.9706, lng: 30.1044, zoom: 10 },
    "Africa/Lubumbashi": { lat: -11.6609, lng: 27.4794, zoom: 10 },
    "Africa/Lusaka": { lat: -15.3875, lng: 28.3228, zoom: 10 },
    "Africa/Maputo": { lat: -25.9692, lng: 32.5732, zoom: 10 },
    "Africa/Maseru": { lat: -29.3151, lng: 27.4869, zoom: 10 },
    "Africa/Mbabane": { lat: -26.3054, lng: 31.1367, zoom: 10 },
    "Africa/Tripoli": { lat: 32.8872, lng: 13.1913, zoom: 10 },
    "Africa/Windhoek": { lat: -22.5597, lng: 17.0832, zoom: 10 },
    "Antarctica/Troll": { lat: -72.0114, lng: 2.5347, zoom: 10 },
    "Arctic/Longyearbyen": { lat: 78.2232, lng: 15.6267, zoom: 10 },
    "Europe/Amsterdam": { lat: 52.3676, lng: 4.9041, zoom: 12 },
    "Europe/Andorra": { lat: 42.5462, lng: 1.6016, zoom: 10 },
    "Europe/Belgrade": { lat: 44.7866, lng: 20.4489, zoom: 10 },
    "Europe/Berlin": { lat: 52.52, lng: 13.405, zoom: 12 },
    "Europe/Bratislava": { lat: 48.1486, lng: 17.1077, zoom: 10 },
    "Europe/Brussels": { lat: 50.8503, lng: 4.3517, zoom: 12 },
    "Europe/Budapest": { lat: 47.4979, lng: 19.0402, zoom: 12 },
    "Europe/Busingen": { lat: 47.6983, lng: 8.6914, zoom: 10 },
    "Europe/Copenhagen": { lat: 55.6761, lng: 12.5683, zoom: 12 },
    "Europe/Gibraltar": { lat: 36.1408, lng: -5.3536, zoom: 10 },
    "Europe/Kaliningrad": { lat: 54.7104, lng: 20.4522, zoom: 10 },
    "Europe/Ljubljana": { lat: 46.0569, lng: 14.5058, zoom: 10 },
    "Europe/Luxembourg": { lat: 49.6116, lng: 6.1319, zoom: 10 },
    "Europe/Madrid": { lat: 40.4168, lng: -3.7038, zoom: 12 },
    "Europe/Malta": { lat: 35.9375, lng: 14.3754, zoom: 10 },
    "Europe/Monaco": { lat: 43.7384, lng: 7.4246, zoom: 10 },
    "Europe/Oslo": { lat: 59.9139, lng: 10.7522, zoom: 12 },
    "Europe/Paris": { lat: 48.8566, lng: 2.3522, zoom: 12 },
    "Europe/Podgorica": { lat: 42.4411, lng: 19.2636, zoom: 10 },
    "Europe/Prague": { lat: 50.0755, lng: 14.4378, zoom: 12 },
    "Europe/Rome": { lat: 41.9028, lng: 12.4964, zoom: 12 },
    "Europe/San_Marino": { lat: 43.9424, lng: 12.4578, zoom: 10 },
    "Europe/Sarajevo": { lat: 43.8486, lng: 18.3564, zoom: 10 },
    "Europe/Skopje": { lat: 41.9973, lng: 21.428, zoom: 10 },
    "Europe/Stockholm": { lat: 59.3293, lng: 18.0686, zoom: 12 },
    "Europe/Tirane": { lat: 41.3275, lng: 19.8187, zoom: 10 },
    "Europe/Vaduz": { lat: 47.141, lng: 9.5209, zoom: 10 },
    "Europe/Vatican": { lat: 41.9029, lng: 12.4534, zoom: 10 },
    "Europe/Vienna": { lat: 48.2082, lng: 16.3738, zoom: 12 },
    "Europe/Warsaw": { lat: 52.2297, lng: 21.0122, zoom: 12 },
    "Europe/Zagreb": { lat: 45.815, lng: 15.9819, zoom: 10 },
    "Europe/Zurich": { lat: 47.3769, lng: 8.5417, zoom: 12 },

    // Middle East/Africa UTC+03:00
    "Africa/Addis_Ababa": { lat: 9.145, lng: 38.7451, zoom: 10 },
    "Africa/Asmara": { lat: 15.3229, lng: 38.9251, zoom: 10 },
    "Africa/Dar_es_Salaam": { lat: -6.7924, lng: 39.2083, zoom: 10 },
    "Africa/Djibouti": { lat: 11.8251, lng: 42.5903, zoom: 10 },
    "Africa/Juba": { lat: 4.8594, lng: 31.5713, zoom: 10 },
    "Africa/Kampala": { lat: 0.3476, lng: 32.5825, zoom: 10 },
    "Africa/Mogadishu": { lat: 2.0469, lng: 45.3182, zoom: 10 },
    "Africa/Nairobi": { lat: -1.2921, lng: 36.8219, zoom: 12 },
    "Antarctica/Syowa": { lat: -69.0041, lng: 39.59, zoom: 10 },
    "Asia/Aden": { lat: 12.7797, lng: 45.0365, zoom: 10 },
    "Asia/Amman": { lat: 31.9454, lng: 35.9284, zoom: 10 },
    "Asia/Baghdad": { lat: 33.3152, lng: 44.3661, zoom: 10 },
    "Asia/Bahrain": { lat: 26.0667, lng: 50.5577, zoom: 10 },
    "Asia/Beirut": { lat: 33.8547, lng: 35.8623, zoom: 10 },
    "Asia/Damascus": { lat: 33.5138, lng: 36.2765, zoom: 10 },
    "Asia/Famagusta": { lat: 35.1264, lng: 33.9478, zoom: 10 },
    "Asia/Gaza": { lat: 31.3547, lng: 34.3088, zoom: 10 },
    "Asia/Hebron": { lat: 31.5326, lng: 35.0998, zoom: 10 },
    "Asia/Jerusalem": { lat: 31.7683, lng: 35.2137, zoom: 10 },
    "Asia/Kuwait": { lat: 29.3117, lng: 47.4818, zoom: 10 },
    "Asia/Nicosia": { lat: 35.1856, lng: 33.3823, zoom: 10 },
    "Asia/Qatar": { lat: 25.2854, lng: 51.531, zoom: 10 },
    "Asia/Riyadh": { lat: 24.7136, lng: 46.6753, zoom: 10 },
    "Europe/Athens": { lat: 37.9755, lng: 23.7348, zoom: 12 },
    "Europe/Bucharest": { lat: 44.4268, lng: 26.1025, zoom: 10 },
    "Europe/Chisinau": { lat: 47.0105, lng: 28.8638, zoom: 10 },
    "Europe/Helsinki": { lat: 60.1699, lng: 24.9384, zoom: 12 },
    "Europe/Istanbul": { lat: 41.0082, lng: 28.9784, zoom: 12 },
    "Europe/Kiev": { lat: 50.4501, lng: 30.5234, zoom: 12 },
    "Europe/Kirov": { lat: 58.6003, lng: 49.6679, zoom: 10 },
    "Europe/Mariehamn": { lat: 60.0973, lng: 19.9348, zoom: 10 },
    "Europe/Minsk": { lat: 53.9045, lng: 27.5615, zoom: 10 },
    "Europe/Moscow": { lat: 55.7558, lng: 37.6173, zoom: 12 },
    "Europe/Riga": { lat: 56.9496, lng: 24.1052, zoom: 10 },
    "Europe/Simferopol": { lat: 44.9572, lng: 34.1108, zoom: 10 },
    "Europe/Sofia": { lat: 42.6977, lng: 23.3219, zoom: 10 },
    "Europe/Tallinn": { lat: 59.437, lng: 24.7536, zoom: 10 },
    "Europe/Uzhgorod": { lat: 48.6208, lng: 22.3047, zoom: 10 },
    "Europe/Vilnius": { lat: 54.6872, lng: 25.2797, zoom: 10 },
    "Europe/Zaporozhye": { lat: 47.8388, lng: 35.1396, zoom: 10 },
    "Indian/Antananarivo": { lat: -18.8792, lng: 47.5079, zoom: 10 },
    "Indian/Comoro": { lat: -11.6455, lng: 43.3333, zoom: 10 },
    "Indian/Mayotte": { lat: -12.8275, lng: 45.1662, zoom: 10 },

    // Central Asia UTC+04:00
    "Asia/Baku": { lat: 40.4093, lng: 49.8671, zoom: 10 },
    "Asia/Dubai": { lat: 25.2048, lng: 55.2708, zoom: 12 },
    "Asia/Muscat": { lat: 23.5859, lng: 58.4059, zoom: 10 },
    "Asia/Tbilisi": { lat: 41.7151, lng: 44.8271, zoom: 10 },
    "Asia/Yerevan": { lat: 40.0691, lng: 44.5094, zoom: 10 },
    "Europe/Astrakhan": { lat: 46.3478, lng: 48.0406, zoom: 10 },
    "Europe/Samara": { lat: 53.2001, lng: 50.15, zoom: 10 },
    "Europe/Saratov": { lat: 51.5406, lng: 46.0086, zoom: 10 },
    "Europe/Ulyanovsk": { lat: 54.3142, lng: 48.4031, zoom: 10 },
    "Europe/Volgograd": { lat: 48.708, lng: 44.5133, zoom: 10 },
    "Indian/Mahe": { lat: -4.6796, lng: 55.492, zoom: 10 },
    "Indian/Mauritius": { lat: -20.3484, lng: 57.5522, zoom: 10 },
    "Indian/Reunion": { lat: -21.1151, lng: 55.5364, zoom: 10 },

    // UTC+04:30
    "Asia/Kabul": { lat: 34.5553, lng: 69.2075, zoom: 10 },
    "Asia/Tehran": { lat: 35.6892, lng: 51.389, zoom: 12 },

    // Central Asia UTC+05:00
    "Antarctica/Mawson": { lat: -67.6047, lng: 62.8708, zoom: 10 },
    "Asia/Aqtau": { lat: 43.6506, lng: 51.2, zoom: 10 },
    "Asia/Aqtobe": { lat: 50.2839, lng: 57.167, zoom: 10 },
    "Asia/Ashgabat": { lat: 37.9601, lng: 58.3261, zoom: 10 },
    "Asia/Atyrau": { lat: 47.1164, lng: 51.9255, zoom: 10 },
    "Asia/Dushanbe": { lat: 38.5598, lng: 68.787, zoom: 10 },
    "Asia/Karachi": { lat: 24.8607, lng: 67.0011, zoom: 12 },
    "Asia/Oral": { lat: 51.2333, lng: 51.3667, zoom: 10 },
    "Asia/Samarkand": { lat: 39.627, lng: 66.975, zoom: 10 },
    "Asia/Tashkent": { lat: 41.2995, lng: 69.2401, zoom: 10 },
    "Asia/Yekaterinburg": { lat: 56.8431, lng: 60.6454, zoom: 10 },
    "Indian/Kerguelen": { lat: -49.2804, lng: 69.3486, zoom: 10 },
    "Indian/Maldives": { lat: 3.2028, lng: 73.2207, zoom: 10 },

    // India UTC+05:30
    "Asia/Colombo": { lat: 6.9271, lng: 79.8612, zoom: 10 },
    "Asia/Kolkata": { lat: 22.5726, lng: 88.3639, zoom: 12 },

    // Nepal UTC+05:45
    "Asia/Kathmandu": { lat: 27.7172, lng: 85.324, zoom: 10 },

    // Central Asia UTC+06:00
    "Antarctica/Vostok": { lat: -78.4647, lng: 106.835, zoom: 10 },
    "Asia/Almaty": { lat: 43.222, lng: 76.8512, zoom: 10 },
    "Asia/Bishkek": { lat: 42.8746, lng: 74.5698, zoom: 10 },
    "Asia/Dhaka": { lat: 23.8103, lng: 90.4125, zoom: 12 },
    "Asia/Omsk": { lat: 54.9885, lng: 73.3242, zoom: 10 },
    "Asia/Qyzylorda": { lat: 44.8479, lng: 65.5094, zoom: 10 },
    "Asia/Thimphu": { lat: 27.4728, lng: 89.639, zoom: 10 },
    "Asia/Urumqi": { lat: 43.7793, lng: 87.6177, zoom: 10 },
    "Indian/Chagos": { lat: -6.3432, lng: 71.8765, zoom: 10 },

    // Southeast Asia UTC+06:30
    "Asia/Yangon": { lat: 16.8661, lng: 96.1951, zoom: 10 },
    "Indian/Cocos": { lat: -12.1642, lng: 96.871, zoom: 10 },

    // Southeast Asia UTC+07:00
    "Antarctica/Davis": { lat: -68.5794, lng: 77.9681, zoom: 10 },
    "Asia/Bangkok": { lat: 13.7563, lng: 100.5018, zoom: 12 },
    "Asia/Barnaul": { lat: 53.3606, lng: 83.7636, zoom: 10 },
    "Asia/Ho_Chi_Minh": { lat: 10.8231, lng: 106.6297, zoom: 12 },
    "Asia/Hovd": { lat: 48.0056, lng: 91.6419, zoom: 10 },
    "Asia/Jakarta": { lat: -6.2088, lng: 106.8456, zoom: 12 },
    "Asia/Krasnoyarsk": { lat: 56.0184, lng: 92.8672, zoom: 10 },
    "Asia/Novokuznetsk": { lat: 53.7596, lng: 87.1216, zoom: 10 },
    "Asia/Novosibirsk": { lat: 55.0084, lng: 82.9357, zoom: 10 },
    "Asia/Phnom_Penh": { lat: 11.5449, lng: 104.8922, zoom: 10 },
    "Asia/Pontianak": { lat: -0.0263, lng: 109.3425, zoom: 10 },
    "Asia/Tomsk": { lat: 56.5017, lng: 84.9716, zoom: 10 },
    "Asia/Vientiane": { lat: 17.9757, lng: 102.6331, zoom: 10 },
    "Indian/Christmas": { lat: -10.5255, lng: 105.6811, zoom: 10 },

    // East Asia UTC+08:00
    "Antarctica/Casey": { lat: -66.2819, lng: 110.5275, zoom: 10 },
    "Asia/Brunei": { lat: 4.5353, lng: 114.7277, zoom: 10 },
    "Asia/Choibalsan": { lat: 48.0568, lng: 114.5136, zoom: 10 },
    "Asia/Hong_Kong": { lat: 22.3193, lng: 114.1694, zoom: 12 },
    "Asia/Irkutsk": { lat: 52.2978, lng: 104.2964, zoom: 10 },
    "Asia/Kuala_Lumpur": { lat: 3.139, lng: 101.6869, zoom: 12 },
    "Asia/Kuching": { lat: 1.5533, lng: 110.3592, zoom: 10 },
    "Asia/Macau": { lat: 22.1987, lng: 113.5439, zoom: 10 },
    "Asia/Makassar": { lat: -5.1477, lng: 119.4327, zoom: 10 },
    "Asia/Manila": { lat: 14.5995, lng: 120.9842, zoom: 12 },
    "Asia/Shanghai": { lat: 31.2304, lng: 121.4737, zoom: 12 },
    "Asia/Singapore": { lat: 1.3521, lng: 103.8198, zoom: 12 },
    "Asia/Taipei": { lat: 25.033, lng: 121.5654, zoom: 12 },
    "Asia/Ulaanbaatar": { lat: 47.8864, lng: 106.9057, zoom: 10 },
    "Australia/Perth": { lat: -31.9505, lng: 115.8605, zoom: 12 },

    // Australia UTC+08:45
    "Australia/Eucla": { lat: -31.6833, lng: 128.8833, zoom: 10 },

    // East Asia UTC+09:00
    "Asia/Chita": { lat: 52.0307, lng: 113.5006, zoom: 10 },
    "Asia/Dili": { lat: -8.5569, lng: 125.5603, zoom: 10 },
    "Asia/Jayapura": { lat: -2.5333, lng: 140.7, zoom: 10 },
    "Asia/Khandyga": { lat: 62.6564, lng: 135.5539, zoom: 10 },
    "Asia/Pyongyang": { lat: 39.0392, lng: 125.7625, zoom: 10 },
    "Asia/Seoul": { lat: 37.5665, lng: 126.978, zoom: 12 },
    "Asia/Tokyo": { lat: 35.6762, lng: 139.6503, zoom: 12 },
    "Asia/Yakutsk": { lat: 62.0355, lng: 129.6755, zoom: 10 },
    "Pacific/Palau": { lat: 7.515, lng: 134.5825, zoom: 10 },

    // Australia UTC+09:30
    "Australia/Adelaide": { lat: -34.9285, lng: 138.6007, zoom: 12 },
    "Australia/Broken_Hill": { lat: -31.9505, lng: 141.4333, zoom: 10 },
    "Australia/Darwin": { lat: -12.4634, lng: 130.8456, zoom: 10 },

    // Australia/Pacific UTC+10:00
    "Antarctica/DumontDUrville": { lat: -66.6628, lng: 140.0014, zoom: 10 },
    "Asia/Ust-Nera": { lat: 64.5603, lng: 143.2267, zoom: 10 },
    "Asia/Vladivostok": { lat: 43.1056, lng: 131.8735, zoom: 10 },
    "Australia/Brisbane": { lat: -27.4698, lng: 153.0251, zoom: 12 },
    "Australia/Currie": { lat: -39.9289, lng: 143.8689, zoom: 10 },
    "Australia/Hobart": { lat: -42.8821, lng: 147.3272, zoom: 12 },
    "Australia/Lindeman": { lat: -20.2697, lng: 149.0431, zoom: 10 },
    "Australia/Melbourne": { lat: -37.8136, lng: 144.9631, zoom: 12 },
    "Australia/Sydney": { lat: -33.8688, lng: 151.2093, zoom: 12 },
    "Pacific/Chuuk": { lat: 7.4256, lng: 151.783, zoom: 10 },
    "Pacific/Guam": { lat: 13.4443, lng: 144.7937, zoom: 10 },
    "Pacific/Port_Moresby": { lat: -9.4438, lng: 147.1803, zoom: 10 },
    "Pacific/Saipan": { lat: 15.1979, lng: 145.7547, zoom: 10 },

    // Australia UTC+10:30
    "Australia/Lord_Howe": { lat: -31.5556, lng: 159.0833, zoom: 10 },

    // Pacific UTC+11:00
    "Antarctica/Macquarie": { lat: -54.62, lng: 158.856, zoom: 10 },
    "Asia/Magadan": { lat: 59.5684, lng: 150.8048, zoom: 10 },
    "Asia/Sakhalin": { lat: 50.4265, lng: 142.7986, zoom: 10 },
    "Asia/Srednekolymsk": { lat: 67.4569, lng: 153.7142, zoom: 10 },
    "Pacific/Bougainville": { lat: -6.2088, lng: 155.2433, zoom: 10 },
    "Pacific/Efate": { lat: -17.7333, lng: 168.3167, zoom: 10 },
    "Pacific/Guadalcanal": { lat: -9.428, lng: 159.955, zoom: 10 },
    "Pacific/Kosrae": { lat: 5.3594, lng: 163.0089, zoom: 10 },
    "Pacific/Norfolk": { lat: -29.0408, lng: 167.9547, zoom: 10 },
    "Pacific/Noumea": { lat: -22.2758, lng: 166.4581, zoom: 10 },
    "Pacific/Pohnpei": { lat: 6.8874, lng: 158.215, zoom: 10 },

    // Pacific UTC+12:00
    "Antarctica/McMurdo": { lat: -77.8419, lng: 166.6863, zoom: 10 },
    "Asia/Anadyr": { lat: 64.7353, lng: 177.5169, zoom: 10 },
    "Asia/Kamchatka": { lat: 53.0138, lng: 158.65, zoom: 10 },
    "Pacific/Auckland": { lat: -36.8485, lng: 174.7633, zoom: 12 },
    "Pacific/Fiji": { lat: -16.5782, lng: 179.4144, zoom: 10 },
    "Pacific/Funafuti": { lat: -8.5167, lng: 179.2167, zoom: 10 },
    "Pacific/Kwajalein": { lat: 8.7256, lng: 167.7311, zoom: 10 },
    "Pacific/Majuro": { lat: 7.1315, lng: 171.1845, zoom: 10 },
    "Pacific/Nauru": { lat: -0.5228, lng: 166.9315, zoom: 10 },
    "Pacific/Tarawa": { lat: 1.3278, lng: 172.9786, zoom: 10 },
    "Pacific/Wake": { lat: 19.2823, lng: 166.6006, zoom: 10 },
    "Pacific/Wallis": { lat: -13.3014, lng: -176.1992, zoom: 10 },

    // Pacific UTC+12:45
    "Pacific/Chatham": { lat: -43.9553, lng: -176.5517, zoom: 10 },

    // Pacific UTC+13:00
    "Pacific/Apia": { lat: -13.8506, lng: -171.7513, zoom: 10 },
    "Pacific/Enderbury": { lat: -3.1339, lng: -171.0842, zoom: 10 },
    "Pacific/Fakaofo": { lat: -9.3658, lng: -171.2186, zoom: 10 },
    "Pacific/Tongatapu": { lat: -21.1789, lng: -175.1982, zoom: 10 },

    // Pacific UTC+14:00
    "Pacific/Kiritimati": { lat: 1.8721, lng: -157.4278, zoom: 10 },

    // Legacy mappings for compatibility
    "Asia/Hanoi": { lat: 21.0278, lng: 105.8342, zoom: 12 },
  };
  return map[tz] || null;
};